import { ArpMedia, PaginatedResponse } from '@arpeggi/shared'
import { ApiService } from 'features/api'
import { useInfiniteQuery, UseInfiniteQueryOptions } from 'react-query'
import { getNextPage, getPreviousPage } from '../../../__legacy__/queries/common'
import { GetSongRemixesParams } from '../../api/types/arpMedia'

export const useSongRemixes = ({
  songId,
  params,
  options
}: {
  songId: number
  params?: GetSongRemixesParams
  options?: UseInfiniteQueryOptions<PaginatedResponse<ArpMedia>>
}) => {
  return useInfiniteQuery(
    ['songs', songId, 'remixes', params],
    ({ pageParam = params?.page || 1 }) =>
      ApiService.ArpMedia.songs.endpoints.remixes.getMany(songId, { ...params, page: pageParam }),
    {
      getPreviousPageParam: (firstPage) => getPreviousPage(firstPage),
      getNextPageParam: (lastPage) => getNextPage(lastPage),
      ...options
    }
  )
}
